<template>
  <div>
    <v-btn small icon @click.stop="handleShowFormClick">
      <v-icon small>fa-trash</v-icon>
    </v-btn>

    <v-dialog v-model="showModal" max-width="800">
      <v-card v-if="showModal">
        <v-card-title class="headline">Delete invoice {{invoiceId}}?</v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleSendForm">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import DateWithMinutes from '../../Filters/DateWithMinutes'
  import NoEmpty from '../../Filters/NoEmpty'
  import {mapActions} from "vuex";
  import {notificationService} from '../../../application'

  export default {
    name: 'delete-invoice-form',
    components: {},
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    props: {
      invoiceId: {
        type: Number,
        required: true,
      }
    },
    data() {
      return {
        showModal: false,
        form: {}
      }
    },
    methods: {
      ...mapActions({
        invoicesDeleteInvoice: 'invoicesDeleteInvoice',
      }),
      handleShowFormClick() {
        this.showModal = true
      },
      handleSendForm() {
        this
          .invoicesDeleteInvoice({
            invoiceId: this.invoiceId,
          })
          .then(() => {
            this.showModal = false
          })
          .catch(e => {
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = {}
      },
      handleHideForm() {
        this.resetForm();
        this.showModal = false
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/DeleteInvoiceForm.vue